import { forwardRef, Stack, StackProps } from '@bonusly/design-system';

export const Section = forwardRef<StackProps, 'section'>(({ children, ...rest }: StackProps, ref) => {
	return (
		<Stack as="section" bg="bg.surface" borderRadius="lg" border="1px solid" borderColor="border.soft" gap={4} w="full" px={6} py={6} ref={ref} {...rest}>
			{children}
		</Stack>
	);
});

Section.displayName = 'Section';
